'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _setPrototypeOf(o, p) {
  exports.setPrototypeOf = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

exports.setPrototypeOf = _setPrototypeOf;
